// source: pbtypes/vehicle/complimentary_actions/complimentary_actions_impls/send_mission_control/send_mission_control.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_complimentary_actions_trigger_args_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/trigger_args_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_trigger_args_pb);
goog.exportSymbol('proto.complimentary_actions.MissionControlCopyForComplimentaryActions', null, global);
goog.exportSymbol('proto.complimentary_actions.MissionControlCopyForComplimentaryActions.ControlType', null, global);
goog.exportSymbol('proto.complimentary_actions.SendMissionControlActionArgs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.MissionControlCopyForComplimentaryActions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.MissionControlCopyForComplimentaryActions.displayName = 'proto.complimentary_actions.MissionControlCopyForComplimentaryActions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.SendMissionControlActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.complimentary_actions.SendMissionControlActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.SendMissionControlActionArgs.displayName = 'proto.complimentary_actions.SendMissionControlActionArgs';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.MissionControlCopyForComplimentaryActions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 2, 0),
command: jspb.Message.getFieldWithDefault(msg, 1, 0),
actionUuid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.MissionControlCopyForComplimentaryActions;
  return proto.complimentary_actions.MissionControlCopyForComplimentaryActions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 1:
      var value = /** @type {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions.ControlType} */ (reader.readEnum());
      msg.setCommand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setActionUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.MissionControlCopyForComplimentaryActions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCommand();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getActionUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.ControlType = {
  INVALID: 0,
  START: 1,
  PAUSE: 2,
  ABORT: 3,
  RESUME: 5,
  REQUEST_MISSION: 6,
  ABORT_AUTONOMOUS: 7,
  LAND_IN_PLACE: 8,
  SKIP_TO_WAYPOINT: 9
};

/**
 * optional int64 utime = 2;
 * @return {number}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions} returns this
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional ControlType command = 1;
 * @return {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions.ControlType}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.getCommand = function() {
  return /** @type {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions.ControlType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions.ControlType} value
 * @return {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions} returns this
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.setCommand = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string action_uuid = 3;
 * @return {string}
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.getActionUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.complimentary_actions.MissionControlCopyForComplimentaryActions} returns this
 */
proto.complimentary_actions.MissionControlCopyForComplimentaryActions.prototype.setActionUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.SendMissionControlActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.SendMissionControlActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SendMissionControlActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.toObject(includeInstance, f),
missionControl: (f = msg.getMissionControl()) && proto.complimentary_actions.MissionControlCopyForComplimentaryActions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.SendMissionControlActionArgs}
 */
proto.complimentary_actions.SendMissionControlActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.SendMissionControlActionArgs;
  return proto.complimentary_actions.SendMissionControlActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.SendMissionControlActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.SendMissionControlActionArgs}
 */
proto.complimentary_actions.SendMissionControlActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = new proto.complimentary_actions.MissionControlCopyForComplimentaryActions;
      reader.readMessage(value,proto.complimentary_actions.MissionControlCopyForComplimentaryActions.deserializeBinaryFromReader);
      msg.setMissionControl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.SendMissionControlActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.SendMissionControlActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SendMissionControlActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.serializeBinaryToWriter
    );
  }
  f = message.getMissionControl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.complimentary_actions.MissionControlCopyForComplimentaryActions.serializeBinaryToWriter
    );
  }
};


/**
 * optional TriggerArgs.TimerCallback trigger = 1;
 * @return {?proto.complimentary_actions.TriggerArgs.TimerCallback}
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.getTrigger = function() {
  return /** @type{?proto.complimentary_actions.TriggerArgs.TimerCallback} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback, 1));
};


/**
 * @param {?proto.complimentary_actions.TriggerArgs.TimerCallback|undefined} value
 * @return {!proto.complimentary_actions.SendMissionControlActionArgs} returns this
*/
proto.complimentary_actions.SendMissionControlActionArgs.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SendMissionControlActionArgs} returns this
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MissionControlCopyForComplimentaryActions mission_control = 2;
 * @return {?proto.complimentary_actions.MissionControlCopyForComplimentaryActions}
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.getMissionControl = function() {
  return /** @type{?proto.complimentary_actions.MissionControlCopyForComplimentaryActions} */ (
    jspb.Message.getWrapperField(this, proto.complimentary_actions.MissionControlCopyForComplimentaryActions, 2));
};


/**
 * @param {?proto.complimentary_actions.MissionControlCopyForComplimentaryActions|undefined} value
 * @return {!proto.complimentary_actions.SendMissionControlActionArgs} returns this
*/
proto.complimentary_actions.SendMissionControlActionArgs.prototype.setMissionControl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SendMissionControlActionArgs} returns this
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.clearMissionControl = function() {
  return this.setMissionControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SendMissionControlActionArgs.prototype.hasMissionControl = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.complimentary_actions);
